export const statusColour = (status) => {
    const colorMap = {
        DRAFT: '#aaaaaa',
        NEW: '#66bb6a',
        ACTIVE: '#7bafdf',
        CLOSED: '#000000',
        ON_HOLD: '#ffa726',
    }
    return colorMap[status] || '#eeeeee';
};